import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router';
import '../Styles/ProjectDetails.css'
function ProjectDetails(props) {
    let navigate = useNavigate();
    //console.log(str)
    var str = window.location.href;
    var res = str.split("/").pop();
    const [details, setDetails] = useState(props.path == 'projects' ?
        {
            project_mebers: [],
            max_pay_out: 0,
            client_approved_coast: 0,
            flyaxavi_approved_coast: 0,
            Agree_fee: 0, Normal_fee: 0,
        }
        : {
            consultant_name: '',
            till_project: '',
            currency: '',
            accomendation: '',
            assaigned_project_name: '',
            assaigned_date: '',
            description: '',
            slug: '',
            travel: '',
            Agree_fee: 0,
            Normal_fee: 0,
        })
        const type=localStorage.getItem('type')
    useEffect(async () => {
        var str = window.location.href;
        var res = str.split("/").pop();
        let det= await JSON.parse(localStorage.getItem(props.path == 'projects' ? `project-${res}` : `contract-${res}`))
        let data = '';
        if (props.path == 'projects') {
            if (!det) {
                // navigate('/projects')
                await axios.get(`${process.env.REACT_APP_API_URL1}/${type=='HR'?'hr':'project'}/projects/${res}/`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `JWT ${localStorage.getItem('access')}`,
                        'Accept': 'application/json'
                    }
                })
                    .then(response => {
                        setDetails(response.data);
                    }).catch(err => {
                        console.log(err)
                    })
                    return
            }
            else{
                // localStorage.removeItem(`project-${res}`)
                console.log(det)
                setDetails(det)
            }
        }
        else {
            if (!det) {
                // navigate('/contracts')
                console.log(det)
                await axios.get(`${process.env.REACT_APP_API_URL1}/hr/contract/${res}/`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `JWT ${localStorage.getItem('access')}`,
                        'Accept': 'application/json'
                    }
                })
                    .then(response => {
                        setDetails(response.data)
                        // for (const property in response.data) {
                        //     console.log(`${property}: ${response.data[property]}`);
                        // document.getElementById('addtab').innerHTML+=`
                        // <tr>
                        //     <td><b>${property}</b>&emsp; :&emsp;${response.data[property]==='true'?'YES':response.data[property]==='false'?"NO":response.data[property]}</td>
                        // </tr>
                        // `
                        // }
                        return
                    }).catch(err => {
                        console.log(err)
                    })
            }
            else { 
                setDetails(det)
            localStorage.removeItem(`contract-${res}`)
            }
        }
    }, [])
    // let cur=JSON.parse(localStorage.getItem('currency'))
    // let Scur=localStorage.getItem('selectedCurrency')
    // let symbol=localStorage.getItem('symbol')
    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return (
        <div className='p-details indinv'>
            <h1>{props.path == 'projects' ? 'Project' : 'Contract'}</h1>
            {props.path == 'projects' ? <table className='p-details-table'>
                <tr>
                    <td><b>Project Name :</b> {details.project_name}</td>
                    {type != 'CONSULTANT' ?<td><b>Number of Resources :</b>{details.no_of_resources}</td>:<td><b>Status :</b>{details.status}</td>}
                </tr>
                <tr>
                 <td><b>Project Location :</b>{details.project_location}</td>
                    <td><b>From :</b> {details.approx_start_date}</td>
                </tr>
                <tr>
                {type != 'CONSULTANT' ?<td><b>Customer/ vendor :</b>{details.customer}</td>:<></>}
                    <td><b>Duration :</b> {details.approx_duration}</td>
                </tr>

                <tr>
                    <td><b>specification :</b>{details.specififcation}</td>
                    {type != 'CONSULTANT' ?<td><b>Project Members :</b>{details.project_mebers&&details.project_mebers.map((e) => { return e.first_name + " " + e.last_name + ", " })}</td>:<></>}
                </tr>
                {type != 'CONSULTANT' ?<><tr>
                    {/* <td><b>Candidate max payout :</b>{numberWithCommas(details.max_pay_out) + details.currency}</td> */}
                    <td><b>Client Approved cost :</b>{numberWithCommas(details.client_approved_coast) + details.currency}</td>
                </tr>
                <tr>
                    <td><b>Flyxavi Approved Cost :</b>{numberWithCommas(details.flyaxavi_approved_coast) + details.currency}</td>
                </tr><br />
                {/* <tr> */}
                <b className='myFont'>Info for HR :</b>{details.information_for_hr}<br /><br />
                {/* </tr> */}
                {/* <tr> */}
                <b className='myFont'>Additional Details :</b>{details.additional_detailes}
                {/* </tr> */}</>:<></>}
            </table> :

                //contract view
                <table className='p-details-table ' id='addtab'>
                    <tr>
                        <td><b>Consultant Name : </b>{details.consultant_name}</td>
                        <td><b>Project Name : </b>{details.assaigned_project_name}</td>
                    </tr>
                    <tr>
                        <td><b>Assigned Project : </b>{details.assaigned_project_name}</td>
                        <td><b>Assigned on : </b>{Date(details.assaigned_date)}</td>
                    </tr>
                    <tr>
                        <td><b>Agreed Fee : </b>{details.Agree_fee && numberWithCommas(details.Agree_fee) + details.currency}</td>
                        <td><b>Normal Fee : </b>{details.Normal_fee && numberWithCommas(details.Normal_fee) + details.currency}</td>
                    </tr>
                    <tr>
                        <td><b>Accomodation : </b>{details.accomendation ? 'Yes' : 'No'}</td>
                        <td><b>Travel : </b>{details.travel ? 'Yes' : 'No'}</td>
                    </tr><br />
                    <b className='myFont'>Till Project : </b>{details.till_project}<br />
                    <b className='myFont'>Desctiption : </b>{details.description}
                </table>
            }
            <div className='indinvB'>
                <button type='button' onClick={() => navigate(-1)} className='indinvsec'>Back</button>
                <button type='submit' onClick={() => { window.print() }}>Print</button>
            </div>
        </div>
    )
}

export default ProjectDetails